import * as R from 'ramda';
import generator from 'redux/hor/module';
import fetchWithView from 'redux/utils/fetchWithView';

const {
  reducer,
  fetch,
} = generator({
  name: 'ProductGroups',
  tableId: 52,
  parseItem: R.evolve({
    custom_производитель: R.propOr(null, 'key'),
  }),
});

export const fetchList = fetchWithView(fetch, 'ts5c52cs9r342', {
  useLS: true,
});

export {
  getKeyById,
  getItemById,
  getItem,
} from 'redux/hor/module/selectors';

export {
  getGroups,
  getCatalogGroups,
  getSelectData,
} from './selectors';

export default reducer;
